import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import theme from '../../styles/theme'

type CardProps = {
  color?: string
}

export const ContainerCard = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    border-radius: ${theme.border.cardRadius};
    width: 100%;
    padding: 20px 20px;
    border: 1px solid ${theme.colors.xxlightGray};
    box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-top: 50px;
    &:before {
      content: '';
      width: 3px;
      display: flex;
      height: 100%;
      background: ${(e: CardProps) => e.color};
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 30px;
    }
  `}
`
export const DropdownAction = styled.div`
  span {
    display: flex;
    flex-direction: column;
  }
  background-color: #fff;
  box-shadow: 1px 1px 5px 0px #0000001a;
  padding: 15px 0;
  border-radius: 8px 0px 8px 8px;
  position: absolute;
  top: 20px;
  right: 0;
  min-width: 182px;
`
export const SeeMore = styled(Link)`
  font-family: ${theme.font.montserrat};
  font-size: 0.7rem;
  color: ${theme.colors.blue};
  width: 100%;
  display: flex !important;
  justify-content: flex-end;
  cursor: pointer;
  text-decoration: none;
  margin-top: 15px;
`
export const Options = styled.span`
  font-family: ${theme.font.montserrat};
  font-size: 0.7rem;
  color: ${theme.colors.black};
  width: 100%;
  display: flex !important;
  justify-content: flex-end;
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 15px;
  letter-spacing: 3px;
`
export const Title = styled.h3`
  font-family: ${theme.font.montserrat};
  font-size: ${theme.font.sizes.normal};
  margin-top: 15px;
`
export const SubTitle = styled.span`
  font-family: ${theme.font.montserrat};
  font-size: 0.7rem;
  margin-top: 15px;
  color: ${theme.colors.gray};
`
export const SubTitleBold = styled.span`
  font-family: ${theme.font.montserrat};
  font-size: 0.7rem;
  margin-top: 15px;
  color: ${theme.colors.black};
  font-weight: ${theme.font.bold};
`
export const AttachLink = styled.button`
  font-family: ${theme.font.montserrat};
  font-size: 0.8rem;
  margin-top: 15px;
  padding-left: 0;
  color: ${theme.colors.gray};
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  background-color: transparent;
  text-decoration: underline;
  color: ${theme.colors.blue};
  svg {
    margin-right: 5px;
  }
`
type ButtonEmission = {
  disabled: boolean
}
export const ButtonEmission = styled(Link)`
  display: flex;
  flex-direction: row;
  text-decoration: none;
  background-color: ${(a: ButtonEmission) =>
    a.disabled ? theme.colors.lightGray : theme.colors.primary};
  color: ${(a: ButtonEmission) =>
    a.disabled ? theme.colors.darkGray : theme.colors.white};
  height: 40px;
  align-items: center;
  padding: 15px;
  border-radius: 8px;
  margin-right: 15px;
  font-size: ${theme.font.sizes.xxxsmall};
  width: 120px;
  justify-content: center;
  cursor: pointer;
  .tags-collapse {
    width: 15px;
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
    background-color: ${theme.colors.white};
    border-radius: 50%;
    svg,
    path {
      width: 8px;
      height: 8px;
      margin-top: 2px;
      fill: ${(a: ButtonEmission) =>
        a.disabled ? theme.colors.darkGray : theme.colors.primary};
    }
  }
  transition: ease all 200ms;
  &:hover {
    opacity: 0.6;
  }
`
export const ButtonEmissionList = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 10px;
`
export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`
export const TableAssesment = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid ${theme.colors.lightGray};
  border-bottom: none;
  margin-top: 15px;
  overflow: hidden;
  a {
    text-decoration: none;
  }
  margin-bottom: 10px;
`
export const ItemTableAssesment = styled.div`
  display: flex;
  flex-direction: row;
  padding: 15px;
  border-bottom: 1px solid ${theme.colors.lightGray};
  font-size: ${theme.font.sizes.normal};
  color: ${theme.colors.darkGray};
  align-items: center;
  font-size: ${theme.font.sizes.normal};
  color: ${theme.colors.darkGray};
  text-decoration: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  .tags-collapse {
    height: 20px;
    display: flex;
    align-items: center;
    p {
      margin-right: 15px;
      color: ${theme.colors.primary};
      background-color: ${theme.colors.lightGreen};
      padding: 7px 15px;
      border-radius: 18px;
    }
  }
`

export const ActionButtonCardCancel = styled.button`
  ${({ theme }) => css`
    color: ${theme.colors.red};
    font-family: ${theme.font.montserrat};
    font-size: ${theme.font.sizes.xxxsmall};
    background-color: transparent;
    padding: 10px 30px;
    width: 100%;
    cursor: pointer;
    transition: ease all 200ms;
    display: flex;
    align-items: center;
    & svg,
    path {
      transition: ease all 200ms;
      fill: ${theme.colors.red};
      margin-right: 10px;
      width: 25px;
      height: 25px;
    }
    :hover {
      background-color: ${theme.colors.lightGray};
      color: ${theme.colors.primary};
      & svg,
      path {
        fill: ${theme.colors.primary};
      }
    }
  `}
`
export const ActionButtonCardCancelAssessment = styled.button`
  ${({ theme }) => css`
    color: ${theme.colors.red};
    font-family: ${theme.font.montserrat};
    font-size: ${theme.font.sizes.xxxsmall};
    background-color: transparent;
    padding: 10px 30px;
    width: 100%;
    cursor: pointer;
    transition: ease all 200ms;
    display: flex;
    align-items: center;
    & svg,
    path {
      transition: ease all 200ms;
      fill: ${theme.colors.red};
      margin-right: 10px;
      width: 25px;
      height: 25px;
    }
    :hover {
      background-color: ${theme.colors.lightGray};
      color: ${theme.colors.primary};
      & svg,
      path {
        fill: ${theme.colors.primary};
      }
    }
  `}
`
export const ActionButtonCard = styled.button`
  ${({ theme }) => css`
    color: ${theme.colors.blue};
    font-family: ${theme.font.montserrat};
    font-size: ${theme.font.sizes.xxxsmall};
    background-color: transparent;
    padding: 10px 30px;
    cursor: pointer;
    transition: ease all 200ms;
    display: flex;
    align-items: center;
    & svg,
    path {
      transition: ease all 200ms;
      fill: ${theme.colors.blue};
      margin-right: 10px;
      width: 25px;
      height: 25px;
    }
    :hover {
      background-color: ${theme.colors.lightGray};
      color: ${theme.colors.primary};
      & svg,
      path {
        fill: ${theme.colors.primary};
      }
    }
  `}
`
export const ActionButtonCardAssement = styled.button`
  ${({ theme }) => css`
    box-shadow: 0px 4px 2px 0px #00000026;

    margin-left: 10px;
    font-family: ${theme.font.montserrat};
    font-size: ${theme.font.sizes.xxxsmall};
    background-color: transparent;
    border: 1px solid ${theme.colors.primary};
    padding: 3px 7px;
    border-radius: 6px;
    cursor: pointer;
    transition: ease all 200ms;
    display: flex;
    :hover {
      background-color: ${theme.colors.primary};
      & svg,
      path {
        fill: #fff;
      }
    }
  `}
`
export const Paragraph = styled.div`
  font-family: ${theme.font.montserrat};
  font-size: 0.8rem;
  margin-top: 15px;
  color: ${theme.colors.gray};
  span {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
export const IconTop = styled.div`
  ${() => css`
    background: ${(e: CardProps) => e.color};
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    position: absolute;
    top: -25px;
    &:before {
      content: '';
      width: 2px;
      background-color: ${(e: CardProps) => e.color};
      height: 30px;
      position: absolute;
      top: -27px;
    }
  `}
`
